import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const RefreshIcon = createSvgIcon(
  <path
    d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.9445 3 17.5587 4.414 19.2007 6.6M19.2007 6.6V3M19.2007 6.6H15.5"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="transparent"
  />,
  "RefreshIcon"
);
